import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const EMPTY_ROUTE = { transportName: '', stationFrom: '', stationTo: '', fare: '', roundTrip: false };

const TransportApply = () => {
  const navigate = useNavigate();

  const [targetDate, setTargetDate] = useState("");
  const [businessPurpose, setBusinessPurpose] = useState("");
  const [businessStartTime, setBusinessStartTime] = useState("");
  const [businessEndTime, setBusinessEndTime] = useState("");
  // 利用交通機関（複数区間）。往復チェック時は金額を2倍で集計。
  const [routes, setRoutes] = useState([]);
  const [showRouteModal, setShowRouteModal] = useState(false);

  // 金額合計（往復は2倍）
  const totalAmount = routes.reduce((sum, r) => {
    const fare = Number(r.fare) || 0;
    return sum + fare * (r.roundTrip ? 2 : 1);
  }, 0);

  const handleRouteChange = (index, field, value) => {
    setRoutes((prev) => prev.map((r, i) => (i === index ? { ...r, [field]: value } : r)));
  };

  const handleAddRoute = () => {
    setRoutes((prev) => [...prev, { ...EMPTY_ROUTE }]);
  };

  const handleRemoveRoute = (index) => {
    setRoutes((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSave = async () => {
    if (!targetDate || !businessPurpose) {
      alert("日付と出張用件を入力してください。");
      return;
    }
    if (businessStartTime && businessEndTime && businessEndTime <= businessStartTime) {
      alert("出張時間は「開始時刻 ＜ 終了時刻」で入力してください。");
      return;
    }
    try {
      const payload = {
        category: "TRANSPORT_ROUND",
        title: `日帰り申請 (${targetDate})`,
        formData: {
          targetDate,
          businessPurpose,
          businessStartTime,
          businessEndTime,
          routes: routes.map((r) => ({
            transportName: r.transportName || '',
            stationFrom: r.stationFrom || '',
            stationTo: r.stationTo || '',
            fare: Number(r.fare) || 0,
            roundTrip: !!r.roundTrip,
          })),
          amount: totalAmount,
        }
      };
      await api.post("/api/forms/submit_transport_apply/", payload);
      alert("日帰り申請を受け付けました。");
      navigate('/applications/history');
    } catch (err) {
      alert("保存に失敗しました。");
    }
  };

  const handleClear = () => {
    if (window.confirm("入力したデータは削除されます。よろしいですか？")) {
      setTargetDate("");
      setBusinessPurpose("");
      setBusinessStartTime("");
      setBusinessEndTime("");
      setRoutes([]);
    }
  };

  return (
    <div style={{ padding: "20px", maxWidth: "600px", margin: "0 auto", fontFamily: "Meiryo, sans-serif" }}>
      <h2 style={{ borderBottom: "2px solid #2e6262", paddingBottom: "10px", color: "#1e3e3e" }}>日帰り申請</h2>

      <div style={{ display: "flex", flexDirection: "column", gap: "15px", marginTop: "20px" }}>
        <div>
          <label style={{ fontWeight: "bold", display: "block", marginBottom: "4px" }}>日付 :</label>
          <input type="date" value={targetDate} onChange={(e) => setTargetDate(e.target.value)} style={{ padding: "8px", width: "100%", boxSizing: "border-box" }} />
        </div>

        <div>
          <label style={{ fontWeight: "bold", display: "block", marginBottom: "4px" }}>出張用件:</label>
          <input type="text" placeholder="例: 〇〇支店へ応援のため" value={businessPurpose} onChange={(e) => setBusinessPurpose(e.target.value)} style={{ padding: "8px", width: "100%", boxSizing: "border-box" }} />
        </div>

        <div>
          <label style={{ fontWeight: "bold", display: "block", marginBottom: "4px" }}>出張時間:</label>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input type="time" value={businessStartTime} onChange={(e) => setBusinessStartTime(e.target.value)} style={{ padding: "8px", flex: 1, boxSizing: "border-box" }} />
            <span style={{ fontWeight: "bold", color: "#475569" }}>〜</span>
            <input type="time" value={businessEndTime} onChange={(e) => setBusinessEndTime(e.target.value)} style={{ padding: "8px", flex: 1, boxSizing: "border-box" }} />
          </div>
          <p style={{ fontSize: "12px", color: "#94a3b8", margin: "4px 0 0" }}>※ 出張の開始時刻〜終了時刻（何時から何時まで）を入力してください。</p>
        </div>

        <div style={{ background: "#f8fafc", padding: "15px", borderRadius: "6px", border: "1px dashed #cbd5e1", display: "flex", flexDirection: "column", gap: "12px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span style={{ fontWeight: "bold", color: "#334155" }}>利用列車:</span>
            <button type="button" onClick={() => setShowRouteModal(true)} style={{ padding: "6px 14px", background: "#0284c7", color: "white", border: "none", borderRadius: "4px", fontWeight: "bold", cursor: "pointer" }}>
              🚊 利用列車を登録
            </button>
          </div>
          {routes.length > 0 ? (
            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              {routes.map((r, i) => (
                <div key={i} style={{ fontSize: "14px", color: "#1e293b", borderTop: i === 0 ? "none" : "1px dashed #e2e8f0", paddingTop: i === 0 ? 0 : "6px" }}>
                  <strong>{r.transportName || "（交通機関未入力）"}</strong>　{r.stationFrom || "?"} 〜 {r.stationTo || "?"}
                  <span style={{ color: "#ea580c", fontWeight: "bold" }}>{(Number(r.fare) || 0).toLocaleString("ja-JP")}円</span>
                  {r.roundTrip && <span style={{ marginLeft: "6px", fontSize: "12px", background: "#e0f2fe", color: "#0369a1", padding: "1px 6px", borderRadius: "4px" }}>往復</span>}
                </div>
              ))}
              <div style={{ borderTop: "1px solid #cbd5e1", paddingTop: "6px", textAlign: "right", fontWeight: "bold" }}>
                精算金額合計: <span style={{ color: "#ea580c", fontSize: "1.1rem" }}>{totalAmount.toLocaleString("ja-JP")} 円</span>
              </div>
            </div>
          ) : (
            <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>※「利用列車を登録」ボタンから交通機関・区間・金額を登録してください。</p>
          )}
        </div>

        <div style={{ display: "flex", gap: "10px", marginTop: "15px", borderTop: "1px solid #e2e8f0", paddingTop: "15px" }}>
          <button type="button" onClick={() => navigate('/applications')} style={{ padding: "10px 20px", background: "#64748b", color: "white", border: "none", borderRadius: "4px", fontWeight: "bold", cursor: "pointer" }}>戻る</button>
          <button type="button" onClick={handleClear} style={{ padding: "10px 20px", background: "#ef4444", color: "white", border: "none", borderRadius: "4px", fontWeight: "bold", cursor: "pointer", marginLeft: "auto" }}> 削除</button>
          <button type="button" onClick={handleSave} style={{ padding: "10px 24px", background: "#16a34a", color: "white", border: "none", borderRadius: "4px", fontWeight: "bold", cursor: "pointer" }}>保存 </button>
        </div>
      </div>

      {/* 利用交通機関 登録モーダル */}
      {showRouteModal && (
        <div
          role="dialog"
          aria-modal="true"
          style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.5)", display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "20px", overflowY: "auto", zIndex: 1000 }}
        >
          <div style={{ background: "#ffffff", borderRadius: "10px", width: "100%", maxWidth: "620px", padding: "20px", boxShadow: "0 10px 30px rgba(0,0,0,0.2)" }}>
            <h3 style={{ color: "#1e3e3e", borderBottom: "2px solid #cbd5e1", paddingBottom: "8px", marginTop: 0 }}>🚊 利用交通機関の登録</h3>

            {routes.length === 0 && (
              <p style={{ fontSize: "13px", color: "#64748b" }}>「＋ 追加」を押して交通機関を登録してください。</p>
            )}

            <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
              {routes.map((r, i) => (
                <div key={i} style={{ border: "1px solid #e2e8f0", borderRadius: "8px", padding: "14px", background: "#f8fafc" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                    <span style={{ fontWeight: "bold", color: "#334155" }}>交通機関 {i + 1}</span>
                    <button type="button" onClick={() => handleRemoveRoute(i)} style={{ padding: "4px 12px", background: "#ef4444", color: "white", border: "none", borderRadius: "4px", fontSize: "13px", cursor: "pointer" }}>削除</button>
                  </div>

                  <div style={{ marginBottom: "8px" }}>
                    <label style={{ fontSize: "13px", fontWeight: "bold", color: "#475569", display: "block", marginBottom: "2px" }}>交通機関:</label>
                    <input type="text" placeholder="例: JR〇〇線" value={r.transportName} onChange={(e) => handleRouteChange(i, "transportName", e.target.value)} style={{ padding: "7px", width: "100%", boxSizing: "border-box" }} />
                  </div>

                  <div style={{ marginBottom: "8px" }}>
                    <label style={{ fontSize: "13px", fontWeight: "bold", color: "#475569", display: "block", marginBottom: "2px" }}>区間:</label>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <input type="text" placeholder="出発駅" value={r.stationFrom} onChange={(e) => handleRouteChange(i, "stationFrom", e.target.value)} style={{ padding: "7px", flex: 1, boxSizing: "border-box" }} />
                      <span style={{ fontWeight: "bold", color: "#475569" }}>〜</span>
                      <input type="text" placeholder="到着駅" value={r.stationTo} onChange={(e) => handleRouteChange(i, "stationTo", e.target.value)} style={{ padding: "7px", flex: 1, boxSizing: "border-box" }} />
                    </div>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <label style={{ fontSize: "13px", fontWeight: "bold", color: "#475569" }}>金額:</label>
                      <input type="number" min="0" placeholder="0" value={r.fare} onChange={(e) => handleRouteChange(i, "fare", e.target.value)} style={{ padding: "7px", width: "120px", boxSizing: "border-box" }} />
                      <span style={{ fontWeight: "bold", color: "#334155" }}>円</span>
                    </div>
                    <label style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "14px", fontWeight: "bold", color: "#334155", cursor: "pointer" }}>
                      <input type="checkbox" checked={r.roundTrip} onChange={(e) => handleRouteChange(i, "roundTrip", e.target.checked)} />
                      往復
                    </label>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ marginTop: "14px" }}>
              <button type="button" onClick={handleAddRoute} style={{ padding: "8px 16px", background: "#0284c7", color: "white", border: "none", borderRadius: "4px", fontWeight: "bold", cursor: "pointer" }}>
                ＋ 追加
              </button>
            </div>

            <div style={{ marginTop: "18px", paddingTop: "14px", borderTop: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontWeight: "bold" }}>合計: <span style={{ color: "#ea580c" }}>{totalAmount.toLocaleString("ja-JP")} 円</span></span>
              <button type="button" onClick={() => setShowRouteModal(false)} style={{ padding: "10px 24px", background: "#16a34a", color: "white", border: "none", borderRadius: "4px", fontWeight: "bold", cursor: "pointer" }}>戻る</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransportApply;
